import { render, staticRenderFns } from "./ReviewSurge.vue?vue&type=template&id=2f55d2fd&scoped=true"
import script from "./ReviewSurge.vue?vue&type=script&lang=js"
export * from "./ReviewSurge.vue?vue&type=script&lang=js"
import style0 from "./ReviewSurge.vue?vue&type=style&index=0&id=2f55d2fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f55d2fd",
  null
  
)

export default component.exports